"use client"

import { useEffect } from "react"
import { KUNCI_SIMPANAN_REFERRAL } from "@/modules/akun/domain/simpanan-referral"
import { rapikanKodeReferral } from "@/modules/akun/domain/referral"

export function PenangkapReferral() {
  useEffect(() => {
    const kode = rapikanKodeReferral(new URLSearchParams(window.location.search).get("ref"))
    if (!kode) return
    try {
      localStorage.setItem(KUNCI_SIMPANAN_REFERRAL, kode)
    } catch {}
  }, [])

  return null
}
